import React  from "react";
import classes from "./CurriculumCard.module.css"
import Card from "../../UI/Card"
import { getClassByNum } from "../../../utils";
import { useSelector } from "react-redux";

const CurriculumCard=({backgroundImage,name,description,year,fromClass,toClass,baseUrl,literalYear})=>{
    const texts = useSelector(state => state.translate.texts);
    
    return  <div className={classes.CurriculumCard}>
        <div className={classes.CurriculumCardWrap}>
            <Card>
                <div className={classes.CurriculumCardContent}>
                    <div className={classes.Img} style={{backgroundImage: `url(${backgroundImage})`}}></div>
                    <div className={classes.Name}>{name}</div>
                    <div className={classes.Desc}>{description}</div>
                </div>
            </Card>
        </div>
        <div className={classes.More}>
            <div className={classes.Year}>{literalYear}</div> 
            <div>|</div>
            <div className={classes.Classes}>{texts.toStudent} {getClassByNum(fromClass)}-{getClassByNum(toClass)}</div>
        </div>
    </div>
}

export default CurriculumCard;